import { useI18n } from '@fusapp-work/shell'
import { tr } from './locales'

const isNamedRole = (name: string): name is keyof typeof tr.names => Object.hasOwn(tr.names, name)

/** Translate known Entra role codes; preserve directory labels for custom roles. */
export function useRoleNames() {
  const { t } = useI18n()
  return (name: string | null | undefined, displayName?: string | null) =>
    name && isNamedRole(name) ? t(`consoleRoles.names.${name}`) : displayName ?? t('consolePersonnel.unavailable')
}
